
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18.02"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0C4.037 0 0 4.041 0 9.008s4.037 9.008 9 9.008 9-4.041 9-9.008S13.963 0 9 0zm0 1.351c4.233 0 7.65 3.42 7.65 7.657A7.643 7.643 0 019 16.665a7.643 7.643 0 01-7.65-7.657A7.643 7.643 0 019 1.351z"}}),_c('path',{attrs:{"d":"M9 2.702a.675.676 0 00-.675.676v5.63a.675.676 0 00.253.528l4.5 3.603a.675.676 0 00.95-.106.675.676 0 00-.106-.95l-4.247-3.4V3.378A.675.676 0 009 2.702z"}})])
          )
        }
      }
    